import axios from 'axios';
import { endServerSession } from '../../components/authProvider/tabSession';

const SERVER_URL = process.env.REACT_APP_API_URL;

export const Api = {
  getCsrfToken: async () => {
    try {
      const response = await axios.get(`${SERVER_URL}/api/get-csrf-token`, {
        withCredentials: true,
      });
      return response.data.csrf_token;
    } catch (e) {
      console.error('Error fetching CSRF token:', e);
      throw new Error('Failed to get CSRF token.');
    }
  },

  createAccount: async (data) => {
    const { username, email, password, phone, description, t } = data;

    try {
      let response;
      const options = {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify({ username: username, email: email, password: password, phone: phone, description: description, userType: "client" }),
      };

      const csrfToken = await Api.getCsrfToken();
      response = await fetch(`${SERVER_URL}/api/auth/signup`, options, {
        headers: {
          'X-CSRFToken': csrfToken,
        }
      });

      switch (response.status) {
        case 200:
          const data = await response.json();
          return data;
        case 400:
          throw new Error(t('All fields are required'));
        case 409:
          throw new Error(t('User already exists!'));
        default:
          throw new Error(t('Something went wrong!'));

      }
    } catch (e) {
      console.log("Error", e);
    }
  },

  signIn: async (data) => {
    try {
      const csrfToken = await Api.getCsrfToken();
      const response = await axios.post(`${SERVER_URL}/api/loginUserV2`, data, {
        headers: {
          'X-CSRFToken': csrfToken,
          'Content-Type': 'multipart/form-data',
        },
        withCredentials: true,
      });

      return response;
    } catch (e) {
      return {
        error: true,
        message: e?.response?.data?.error || 'Something went wrong!',
        status: e?.response?.status || 500,
      };
    }
  },

  mfaAuthentication: async (data) => {
    try {
      const csrfToken = await Api.getCsrfToken();
      const response = await axios.post(`${SERVER_URL}/api/mfa_verificationV2`, data, {
        headers: {
          'X-CSRFToken': csrfToken,
          'Content-Type': 'multipart/form-data'
        },
        withCredentials: true,
      });

      return response;
    } catch (e) {
      return {
        error: true,
        message: e?.response?.data?.message || e?.response?.data?.error || 'Something went wrong!',
        status: e?.response?.status || 500,
      };
    }
  },

  forgetPassword: async (data) => {
    try {
      const csrfToken = await Api.getCsrfToken();
      const response = await axios.post(`${SERVER_URL}/api/forgot_passwordV2`, data, {
        headers: {
          'X-CSRFToken': csrfToken,
          'Content-Type': 'multipart/form-data'
         },
        withCredentials: true,
      });

      return response;
    } catch (e) {
      return {
        error: true,
        message: e?.response?.data?.message || 'Something went wrong!',
        status: e?.response?.status || 500,
      };
    }
  },

  resendMfaCode: async () => {
    try {
      const csrfToken = await Api.getCsrfToken();
      const response = await axios.post(`${SERVER_URL}/api/resend_mfaV2`, {}, {
        headers: {
          'X-CSRFToken': csrfToken,
          'Content-Type': 'application/json'
        },
        withCredentials: true,
      });

      return response;
    } catch (e) {
      return {
        error: true,
        message: e?.response?.data?.error || 'Something went wrong!',
        status: e?.response?.status || 500,
      };
    }
  },

  changePassword: async (data) => {
    try {
      const csrfToken = await Api.getCsrfToken();
      const response = await axios.post(`${SERVER_URL}/api/reset_passwordV2`, data, {
        headers: {
          'X-CSRFToken': csrfToken,
          'Content-Type': 'multipart/form-data'

        },
        withCredentials: true,
      });

      return response;
    } catch (e) {
      throw new Error(e.response.data.message || 'Something went wrong');
    }
  },

  // Ends THIS tab's server session (each tab has its own - see
  // components/authProvider/tabSession.js).
  logout: () => endServerSession(),
}
